// extracted by mini-css-extract-plugin
module.exports = {"block":"Expanded_block__2l8OP","active":"Expanded_active__cWTE3"};